var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coinify-callback-page"},[_c('gl-loader',{attrs:{"progress-spinner":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }